import { useQuery } from '@tanstack/react-query';
import { getProfessionalAttestation } from '../../../../services/credentials';
import { AttestationCode } from '../../../../constants';

export const useFetchProfessionalBenevisAttestation = (userId) => {
  const { data, isLoading } = useQuery({
    queryKey: ['getProfessionalAttestation', `${userId}-${AttestationCode.BENEVIS}`],
    queryFn: () => getProfessionalAttestation(userId, AttestationCode.BENEVIS),
  });

  return { data: data?.data?.data || null, isLoading };
};
